import { connect } from 'react-redux';

import { GlobalContextDropdowns } from '../shared/containerComponents/globalContext';

import { isFetchingContextSelector } from './store/selectors';

export const TasksDashboardGlobalContextDropdowns = connect(state => ({
  isFetchingContext: isFetchingContextSelector(state),
}))(GlobalContextDropdowns);

export { default as TasksDashboard } from './tasksDashboard.container';
